<template>
  <vx-card :title="quiz.title">
    <vs-button @click="deleteQuiz" style="left:1.5rem; z-index:9999" class="absolute" color="danger" type="border" icon="icon-trash" icon-pack="feather" icon-after>{{!smallWindow?'حذف الإختبار':''}}</vs-button>
    <vs-tabs>
      <vs-tab :label="!smallWindow?'تفاصيل الإختبار':''" icon="icon-info" icon-pack="feather">
        <div class="vx-row px-2">
          <vx-card title="بيانات الإختبار" class="vx-col lg:w-1/3 w-full my-4" no-shadow card-border>
            <div slot="actions">
              <feather-icon v-if="!isStarted" @click="isQuizFormActive = true" icon="SettingsIcon" class="flex justify-center effect-dropdown cursor-pointer" svg-classes="h-5 w-5"/>
            </div>
            <div class="flex justify-between items-center mb-2 p-2">
              <p class="text-lg">التاريخ</p>
              <p @click="isQuizFormActive = true" class="text-xl text-primary hover:underline cursor-pointer">{{quiz.date_time | date}}</p>
            </div>
            <div class="flex justify-between items-center mb-2 p-2">
              <p class="text-lg">الوقت</p>
              <p @click="isQuizFormActive = true" class="text-xl text-primary hover:underline cursor-pointer">{{quiz.date_time | time}}</p>
            </div>
            <div class="flex p-2 justify-between items-center mb-2">
              <p class="text-lg">المدة الزمنية</p>
              <p @click="isQuizFormActive = true" class="text-xl text-primary hover:underline cursor-pointer">{{quiz.duration}} دقيقة</p>
            </div>
            <div class="flex p-2 justify-between items-center mb-2">
              <p class="text-lg">عشوائية الاسئلة</p>
              <p @click="isQuizFormActive = true" class="text-xl text-primary hover:underline cursor-pointer">{{quiz.randomize_questions ? 'نعم' : 'لا'}}</p>
            </div>
            <div class="flex p-2 justify-between items-center mb-2">
              <p class="text-lg">عدد النماذج</p>
              <p class="text-xl">{{quiz.groups && quiz.groups.length}} نماذج</p>
            </div>
            <div class="flex p-2 justify-between items-center mb-2">
              <p class="text-lg">مجموعات المادة</p>
              <p class="text-xl">{{quiz.course_groups && quiz.course_groups.join(', ')}}</p>
            </div>
            <div class="flex p-2 justify-between items-center mb-2">
              <p class="text-lg">حالة الإختبار</p>
              <p class="text-xl">{{status}}</p>
            </div>
            <vs-button v-if="isStarted" class="w-full mt-2" :to="{name: 'courseQuizCorrection'}">تصحيح الإختبار</vs-button>
          </vx-card>
          <div class="vx-col lg:w-2/3 w-full my-4 px-4">
            <ul class="mb-base list">
              <li class="list__item items-center">
                <feather-icon icon="ChevronsLeftIcon" class="w-5 h-5 ml-1"/>
                <span>حدد اسئلة كل نموذج من نماذج الإختبار عن طريق تبويب "أسئلة الإختبار".</span>
              </li>
              <li class="list__item items-center">
                <feather-icon icon="ChevronsLeftIcon" class="w-5 h-5 ml-1"/>
                <span>قم بتوزيع الطلبة علي مجموعات (نماذج) الإختبار عن طريق تبويب "طلبة الإختبار" (يمكنك توزيعهم عشوائياً بالضغط علي زر "توزيع الطلبة عشوائياً").</span>
              </li>
              <li class="list__item items-center">
                <vs-alert active color="warning">لن يستطيع اي طالب من اجراء الاختبار الا إذا كان موجود في مجموعة (نموذج).</vs-alert>
              </li>
            </ul>
          </div>
        </div>
      </vs-tab>
      <vs-tab :label="!smallWindow?'أسئلة الإختبار':''" icon="icon-help-circle" icon-pack="feather">
        <h3 class="my-base">حدد اسئلة كل مجموعة</h3>
        <quiz-questions :quiz-groups="quiz.groups" :quiz-has-started="isStarted"></quiz-questions>
      </vs-tab>
      <vs-tab :label="!smallWindow?'طلبة الإختبار':''" icon="icon-users" icon-pack="feather">
        <quiz-students :students="students" :quiz-groups="quiz.groups" :quiz-has-started="isStarted"></quiz-students>
      </vs-tab>
    </vs-tabs>
    <quiz-form v-if="!isStarted" @submit="save" :data="quiz" :active.sync="isQuizFormActive"/>
  </vx-card>
</template>

<script>
    import QuizQuestions from './QuizQuestions.vue';
    import QuizStudents from './QuizStudents.vue';
    import quizzesAPI from "@/api/quizzesAPI";
    import courseStudentsAPI from "@/api/courseStudentsAPI";
    import QuizForm from '@/views/course/quizzes/QuizForm'
    import moment from 'moment'

    export default {
      name: "QuizDetails.vue",
      components: {
          QuizForm,
          QuizQuestions,
          QuizStudents
      },
      data() {
          return {
              quiz: {},
              students: [],
              isQuizFormActive: false
          }
      },
      computed: {
        smallWindow() {
            return this.$store.state.windowWidth <= 768
        },
        isStarted() {
          // return this.$store.state.date.getTime() > new Date(this.quiz.date_time).getTime()
          return this.$store.state.date.getTime() > parseInt(moment(this.quiz.date_time).format('x'))
        },
        status() {
            const now = this.$store.state.date.getTime()
            const quizTime = parseInt(moment(this.quiz.date_time).format('x'))
            const afterDuration = quizTime + (this.quiz.duration * 60 * 1000)
            if(now > afterDuration) {
                return 'مكتمل'
            } else if (now > quizTime) {
                return 'لقد بدأ الإختبار'
            } else {
                return 'لم يبدأ بعد'
            }
        }
      },
      methods: {
        save(data) {
            this.quiz.title = data.title
            this.quiz.date_time = data.date_time
            this.quiz.duration = data.duration
            this.quiz.randomize_questions = data.randomize_questions
        },
        loadStudents(){
            courseStudentsAPI.getAll()
              .then(({data}) => {
                  let students = []
                  Object.keys(data.groups).forEach(group => {
                      data.groups[group].forEach(student => {
                          if(!student.is_approved) return
                          if(!this.isStudentInQuiz(student)){
                              student.course_group = group
                              students.push(student)
                          }
                      })
                  })
                  this.students = students
              })
              .catch(error => this.$notifyError(error))
        },
        isStudentInQuiz(student){
            let flag = false
            this.quiz.groups.forEach(group => {
                group.students.forEach(qStudent => {
                    if(student.id === qStudent.id) flag = true
                })
            })
            return flag
        },
        deleteQuiz(){
            const message = 'هل تريد حذف هذا الإختبار؟'
            this.$confirmAlert(null, message, () => {
                quizzesAPI.delete(this.$route.params.quiz_id)
                    .then((response) => {
                        this.$notifySuccess(response.successMessage)
                        this.$router.push({name: 'courseQuizzes', params:{course_id: this.$route.params.course_id}})
                    })
            })
        },
      },
      beforeRouteEnter(to,from,next){
        quizzesAPI.setCourseId(to.params.course_id)
        quizzesAPI.getById(to.params.quiz_id)
              .then( ({data}) => {
                  next(vm => {
                      if(vm.$store.state.date.getTime() > parseInt(moment(data.quiz.date_time).format('x'))) {
                        data.quiz.is_started = true
                      }
                      vm.quiz = data.quiz
                      vm.loadStudents()
                  })
              })
      },
    }
</script>

<style scoped>

</style>
